<template>
  <div
      v-if="views.length"
      class="flex-col gap-y-lg">
    <Coverage
        v-for="(view, idx) in views"
        :key="view.uuid"
        :index="idx"
        :value="view"
        class="flex-col gap-y-sm"
        @update-view="(newView) => updateViewAt(idx, newView)"
       :view-uuid="view.uuid"
    />
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import CoverageField from './CoverageField.vue';
import Coverage from './Coverage.vue'

export default {
  name: "CoverageFields" ,
  components: {
    CoverageField,
    Coverage,
  },
  props: {
    module: String,
  },
  computed: {
    ...mapState(`$_generic_insurance`, {
      views: state => state.form.views,
      policy_view_id: state => state.form.policy_view_id,
    }),
  },
  methods: {
    ...mapMutations(`$_generic_insurance`, {
      setFormViews: 'SET_FORM_VIEWS'
    }),
    updateViewAt(idx, view) {
     let clone = {...this.views};
     clone[idx] = view;
     this.views = clone;
     this.setFormViews(clone);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.divider {
  margin: 0;
  border: 1px solid #EEF2F6;
}
.divider:last-of-type {
  display: none;
}
</style>
